import { nextTick, ref } from 'vue';

export const replaceScanDialogOpen = ref(false);

let resolveConfirm: ((confirmed: boolean) => void) | null = null;

/**
 * Waits for the user to confirm or cancel replacing the current scan.
 * Resolves to `true` when the user chooses to load the new scan.
 */
export async function requestReplaceScanConfirm(): Promise<boolean> {
  replaceScanDialogOpen.value = true;
  await nextTick();
  return new Promise((resolve) => {
    resolveConfirm = resolve;
  });
}

export function confirmReplaceScan() {
  replaceScanDialogOpen.value = false;
  resolveConfirm?.(true);
  resolveConfirm = null;
}

export function cancelReplaceScan() {
  replaceScanDialogOpen.value = false;
  resolveConfirm?.(false);
  resolveConfirm = null;
}

export function onReplaceScanDialogToggle(open: boolean) {
  if (!open && resolveConfirm) {
    cancelReplaceScan();
  }
}
